var _metadata;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgFacebookRound = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  width: 1365.3333,
  height: 1365.3333,
  viewBox: "0 0 1365.3333 1365.3333",
  className: "react-svg"
}, props), _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null)), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1.3333333,0,0,-1.3333333,0,1365.3333)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "scale(0.1)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m 10240,5120 c 0,2827.7 -2292.3,5120 -5120,5120 C 2292.3,10240 0,7947.7 0,5120 0,2564.46 1872.31,446.301 4320,62.1992 V 3640 H 3020 v 1480 h 1300 v 1128 c 0,1283.2 764.38,1992 1933.9,1992 560.17,0 1146.1,-100 1146.1,-100 V 6880 H 6754.38 C 6118.35,6880 5920,6485.33 5920,6080.43 V 5120 H 7340 L 7113,3640 H 5920 V 62.1992 C 8367.69,446.301 10240,2564.46 10240,5120",
  style: {
    fill: "#ffffff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  }
}))));
export default SvgFacebookRound;